import { SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import safeLocalStorage from './safeLocalStorage';
export const getSeatsCountryCode = () => {
  const seatsGate = safeLocalStorage.getItem(`${SEATS_VERSIONS_FEATURE_FLAG}_OVERRIDE`);
  const isUngatedForSeats = seatsGate === 'true';
  return isUngatedForSeats ? 'AU' : null;
};